// API URLs. In the Docker image they come from public/env.js, which the
// container writes at start-up (docker-entrypoint.sh), so one image works for
// staging and production. Locally, they fall back to REACT_APP_* from .env.
const runtime = window.env || {};

export const BASE_URL = runtime.BASE_URL || process.env.REACT_APP_BASE_URL;
export const AUTH_BASE_URL =
  runtime.AUTH_BASE_URL || process.env.REACT_APP_AUTH_BASE_URL;
